export const DEFAULT_MARGIN = 16;
export const TEXT_FONT = '"Work Sans",sans-serif';
export const TITLE_FONT = 'Mikela';
